import { render, staticRenderFns } from "./SimpleCard.vue?vue&type=template&id=1d571413&"
import script from "./SimpleCard.vue?vue&type=script&lang=ts&"
export * from "./SimpleCard.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VRow})
